module.exports = __webpack_public_path__ + "img/cat.888bffb1.jpg";